import React from 'react';
import EvaluatorPaymentRecReport from './EvaluatorPaymentRecReport';
import IobSummary from './IobSummary';
import TaxReport from './TaxReport';
import { makeReportOpener } from '../reportNavTools';

// linkClick: the redux link_click action, bound by the admin page.
export default function buildCorporateOfficeFinanceReportsSections(linkClick) {
  const open = makeReportOpener(linkClick);

  return [
    {
      title: 'Reports',
      cards: [
        {
          title: 'Evaluator Payment Rec Report',
          description: 'Open the evaluator payment reconciliation report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-money-check-dollar',
          onClick: () =>
            open(<EvaluatorPaymentRecReport />, 'Evaluator Payment Rec Report', 'reports_evaluatorpaymentrec'),
        },
        {
          title: 'IOB Summary',
          description: 'Open the inter-office billing (IOB) summary report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-arrow-right-arrow-left',
          onClick: () => open(<IobSummary />, 'IOB Summary', 'reports_iobsummary'),
        },
        {
          title: '1099 Report',
          description: 'Open the 1099 tax report.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-file-invoice',
          onClick: () => open(<TaxReport />, 'Tax Report', 'reports_taxreport'),
        },
      ],
    },
  ];
}
